import { IPalette, ISemanticColors, PartialTheme as FluentPartialTheme, Theme as FluentTheme } from "@fluentui/react";
import { themeList } from "./themeList";

export const twoUIPaletteColors = [
    "themePrimary",
    "themeLighterAlt",
    "themeLighter",
    "themeLight",
    "themeTertiary",
    "themeSecondary",
    "themeDarkAlt",
    "themeDark",
    "themeDarker",
    "neutralLighterAlt",
    "neutralLighter",
    "neutralLight",
    "neutralQuaternaryAlt",
    "neutralTertiary",
    "neutralTertiaryAlt",
    "neutralSecondary",
    "neutralPrimaryAlt",
    "neutralPrimary",
    "neutralDark",
    "neutralMed",
    "neutralHigh",
    "transparent",
    "black",
    "white",
    "redDark",
    "redLight",
    "highlighter"
] as const;

type TwoUIPaletteColors = { [K in typeof twoUIPaletteColors[number]]: string };

export interface Palette extends IPalette, TwoUIPaletteColors { }
export type ColorName = keyof TwoUIPaletteColors | keyof TwoUISemanticColors;

export interface PartialPalette extends Partial<Palette> { }

export const twoUISemanticColors = [
    "navBackground",
    "navItemBackgroundHovered",
    "navItemBackgroundPressed",
    "severeWarning",
    "errorBlockIcon",
    "messageWebSuccess",
    "cautionYellow"
] as const;

type TwoUISemanticColors = { [K in typeof twoUISemanticColors[number]]: string };

export interface SemanticColors extends ISemanticColors, TwoUISemanticColors { }

export interface PartialSemanticColors extends Partial<ISemanticColors>, TwoUISemanticColors { }

/**
 * Used to *define* partial extended Themes, where an extended Theme is a superset
 * of Fluent's theme. This type allows us to define as many or as few colours as we want,
 * as long as they exist in Fluent's default theme.
 */
export interface PartialTheme extends FluentPartialTheme {
    readonly palette: PartialPalette;
    readonly semanticColors: PartialSemanticColors;
}

/**
 * Exported type with mandatory colours in it. When accessing the theme, even if we only defined a
 * PartialTheme, Fluent's default theme will fill in the rest, this type allows us to not have to
 * assert that the colour strings aren't undefined
 */
export interface Theme extends FluentTheme {
    readonly palette: Palette;
    readonly semanticColors: SemanticColors;
}

export type ThemeVariant = typeof themeList[number];
